export const INTERNAL_DOMAIN = "salesbuckets.com";

export function isInternalDomain(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith(`@${INTERNAL_DOMAIN}`);
}
